<template>
  <div class="user-upload">
    <div class="pop-wrapper" v-show="isLeaveConfirm">
      <div class="pop-box">
        <div class="pop-header clearfix">
        </div>
        <div class="pop-body">
          确定要离开？
        </div>
        <div class="pop-footer">
          <a href="javascript:;" class="yes" @click="confirmLeave">确定</a>
          <a href="javascript:;" class="no" @click="cancelLeave">取消</a>
        </div>
      </div>
    </div>

    <div class="left-wrapper">
      <div class="app-detail">
        <router-link to="/s-mart/personal_center/works/" class="app-link">
          <i class="icon-upper"></i>
        </router-link>
        <div class="app">
          <div class="app-img">
            <img src="../../../images/personal_center/icon-upload2.png" alt="">
          </div>
          <span>上传作品</span>
        </div>
      </div>
      <ul class="account-list list-box">
        <li v-for="(item,index) in navList" :class="{'success': navList[index].curStatus === 2, 'editing': navList[index].curStatus === 1}"
          @click="tabChange(index)">
          <a :href="item.href" @click.stop.prevent="go(item.top, index)">
            <i class="bk-icon icon-check-circle-shape" v-if="item.curStatus === 2">
            </i>
            <i class="process" v-else>{{index+1}}</i>
            {{item.label}}
          </a>
        </li>
      </ul>
    </div>
    <div class="right-wrapper">
      <div class="right-box" id="right">
        <form class="bk-form">
          <!-- 基础资料 -->
          <div class="upload-panel" id="anchor-1">
            <h4>基础资料</h4>
            <div class="upload-form">
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 作品名称：
                </label>
                <div class="bk-form-content" :class="input_warning('baseInformation.name')">
                  <input type="text" v-model="baseInformation.name.value" class="bk-form-input workName" name="validation_name" placeholder="此处输入你上传的作品名称，建议30个字符合以内"
                    style="width: 614px" maxlength="30">
                  <span class="tips" style="left: 42%;" v-if="baseInformation.name.isShow">{{baseInformation.name.tips}}</span>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 作品类型：</label>

                <div class="bk-form-content">
                  <bk-selector :list="baseInformation.sysType.list" :selected.sync="baseInformation.sysType.selected" :multi-select="baseInformation.sysType.multiSelect"
                    style="width: 168px; display: inline-block;">
                  </bk-selector>
                </div>
              </div>
              <div class="bk-form-item" v-show="baseInformation.sysType.selected === 1">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 应用ID：
                </label>
                <div class="bk-form-content" :class="input_warning('baseInformation.appID')">
                  <input type="text" v-model="baseInformation.appID.value" class="bk-form-input workId" @input="checkValidate('baseInformation.appID')"name="validation_name" placeholder="由小写英文字母，连接符(-)或数字组成，长度为3~16个字符，并且以字母开头"
                    style="width: 536px" maxlength="30">
                  <span class="tips" style="left: 42%;" v-if="baseInformation.appID.isShow">{{baseInformation.appID.tips}}</span>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 功能类型：</label>
                <div class="bk-form-content" :class="input_warning('baseInformation.funcType')">
                  <bk-selector :list="baseInformation.funcType.list" :selected.sync="baseInformation.funcType.selected" :multi-select="baseInformation.funcType.multiSelect"
                    style="width: 168px; display: inline-block;">
                  </bk-selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 简要概述：</label>
                <div class="bk-form-content" :class="input_warning('baseInformation.overview')">
                  <textarea v-model="baseInformation.overview.value" maxlength="50" class="bk-form-textarea simpleDescription" name="validation_name" placeholder="请输入产品的详细介绍"
                    style="width: 614px; min-height: 70px;"></textarea>
                  <span class="bk-form-number">{{baseInformation.overview.value.length}}</span>
                  <span class="tips" style="left: 42%;">{{baseInformation.overview.tips}}</span>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 功能点描述：</label>
                <div class="bk-form-content" :class="input_warning('baseInformation.functionPoints')" style="width:614px">
                  <span class="tips" style="left: 42%;">{{baseInformation.functionPoints.tips}}</span>
                  <div style="width:614px">
                    <script type="text/plain" id="myEditor" style="width:614px;height:200px;">
                    </script>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 上传作品文件 -->
          <div class="upload-panel" id="anchor-2">
            <h4>上传作品文件</h4>
            <div class="upload-form">
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 版本号：</label>
                <div class="bk-form-content" :class="input_warning('files.version')">
                  <input type="text" v-model="files.version.value" @input="checkValidate('files.version')" class="bk-form-input versionNum" name="validation_name"
                    placeholder="例如：1.1.0" style="width: 298px">
                  <span class="tips" style="left: 20.5%;">{{files.version.tips}}</span>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 版本文件：</label>
                <div class="bk-form-content">
                  <div class="upload-file">
                    <div class="bk-form-input">选择文件</div>
                    <span class="bk-form-tips">仅支持 .zip 格式的压缩文件</span>
                    <input type="file" name="uploadFile" @change="handleFile" title="选择文件">
                  </div>
                </div>
                <!-- 图片/文件的上传的预览 -->
                <div class="bk-form-content" v-show="ableToUpload">
                  <div class="bk-upload-ul" v-if="files.length !== 0 && files">
                    <div class="bk-list-li">
                      <i class="bk-icon icon-file-zip"></i>
                      <div class="bk-list-content">
                        <span class="name">{{files.file.name}}</span>
                        <i class="bk-icon icon-close" @click="deleteFile()" v-if="loadingStatus === 'start'"></i>
                        <i class="bk-icon icon-check-1" v-else></i>
                        <span class="bk-load" v-show="loadingStatus === 'start'">
                          <span :class="[{'loading': loadingStatus === 'start'}, {'totalLoading': loadingStatus === 'complete'}]"></span>
                          <span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 相关信息：</label>
                <div class="bk-form-content">
                  <textarea name="" id="" v-model="files.message" class="bk-form-textarea" placeholder="请将你的作品该版本的功能特性和修改记录按下面例子的格式写下来， 方便你的用户/卖家能够了解版本的差异和优化的细节：
          1. 修复了上个版本遗留的BUG 　　
          2. 修复了因CPU核数超过32个而产生的异常 　　
          3. 优化了不同指标类型的颜色对比度 　　
          4. 优化了日志分割的方式 　　
          5. 新增了Slackware发行版的支持 　　
          6. 新增了导出Excel的功能 　　
          7. 新增了AIX小型机系统的支持" style="width: 614px; height:250px;">
                  </textarea>
                  <!-- <script type="text/plain" id="myEditor" style="width:826px;height:348px;">
                  </script>
                  <div class="clear"></div> -->
                </div>
              </div>
            </div>
            <div class="upload-form upload-form-border">
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required"></span> 体验地址：</label>
                <div class="bk-form-content" :class="input_warning('files.address')">
                  <input type="text" v-model="files.address.value" @input="checkValidate('files.address')" class="bk-form-input" name="validation_name"
                    placeholder="请在此处输入作品的线上体验地址，有助于用户直观的了解你的作品。" style="width: 614px">
                  <span class="tips" style="left: 41%;">{{files.address.tips}}</span>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 开发语言：</label>
                <div class="bk-form-content" id="language">
                  <selector :list="files.devLanguage.list" :selected.sync="files.devLanguage.selected" :multi-select="files.devLanguage.multiSelect"
                    :searchable="files.devLanguage.searchable" style="width: 614px"></selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 浏览器兼容：</label>
                <div class="bk-form-content" id="browser">
                  <selector :list="files.browser.list" :selected.sync="files.browser.selected" :multi-select="files.browser.multiSelect" :searchable="files.browser.searchable"
                    style="width: 614px" ref="browser">
                  </selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 部署环境：</label>
                <div class="bk-form-content" id="surroundings">
                  <selector :list="files.surroundings.list" :selected.sync="files.surroundings.selected" :multi-select="files.surroundings.multiSelect"
                    :searchable="files.surroundings.searchable" style="width: 614px">
                  </selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 界面语言：</label>
                <div class="bk-form-content" id="interface">
                  <selector :list="files.interface.list" :selected.sync="files.interface.selected" :multi-select="files.interface.multiSelect"
                    :searchable="files.interface.searchable" style="width: 614px">
                  </selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 分类标签：</label>
                <div class="bk-form-content">
                  <tag :tags.sync="files.classification" placeholder="请输入不超过5个关键词作为标签，明确的关键词能够帮助用户更精准快速的定位到你的作品！"></tag>
                </div>
                <!-- <div class="bk-form-content">
                  <input type="text" v-tag-input name="classification"  data-role="tagsinput" placeholder="">
                </div> -->
              </div>
            </div>
          </div>
          <!-- 上传作品图片 -->
          <div class="upload-panel" id="anchor-3">
            <h4>上传作品图片</h4>
            <works-pictures @upPictureId="allPictureIds" @removePicture="removePicture"></works-pictures>
          </div>
          <!-- 设置交易模式 -->
          <div class="upload-panel" id="anchor-4">
            <h4>设置交易模式</h4>
            <!-- <trading-mode></trading-mode> -->
            <div class="upload-form">
              <div class="bk-form-item">
                <label class="bk-label">收费模式：</label>
                <div class="bk-form-content">
                  <label class="bk-form-radio" v-for="(item, index) in tradeMode.model" :key="index">
                    <input class="bk-radio-text" type="radio" name="radio1" :value="item.type" v-model="tradeMode.selectedModel">
                    <i class="bk-radio-text">{{item.title}}</i>
                  </label>
                </div>
              </div>
              <div v-if="tradeMode.selectedModel === 0">
                <div class="bk-form-item" style="margin-top: 20px">
                  <label class="bk-label">
                    <span class="bk-label-required">*</span> 收费价格：</label>
                  <div class="bk-form-content">
                    <span class="bk-form-span" style="color: #ff6600;">免费</span>
                  </div>
                </div>
                <div class="bk-form-item">
                  <label class="bk-label">
                    <span class="bk-label-required"></span> 开源协议：</label>
                  <bk-selector :list="tradeMode.openSource.list" :selected.sync="tradeMode.openSource.selected" style="width: 310px; display: inline-block;">

                  </bk-selector>
                </div>
                <div class="bk-form-item">
                  <label class="bk-label">
                    <span class="bk-label-required"></span> 服务支持：</label>
                  <div class="bk-form-content">
                    <bk-selector :list="tradeMode.support.list" :selected.sync="tradeMode.support.selected" style="width: 310px; display: inline-block;">
                    </bk-selector>
                    <!-- <i class="bk-icon icon-attention"></i> -->
                  </div>
                </div>
                <div class="bk-form-item">
                  <label class="bk-label">
                    <span class="bk-label-required"></span> 开源链接：</label>
                  <div class="bk-form-content">
                    <input type="url" class="bk-form-input" v-model="tradeMode.freeUrl" placeholder="请选择" style="width: 614px">
                  </div>
                </div>
              </div>
              <div v-else-if="tradeMode.selectedModel === 1">
                <div class="bk-form-item" style="margin-top: 20px">
                  <label class="bk-label">
                    <span class="bk-label-required">*</span> 收费价格：</label>
                  <div class="bk-form-content">
                    <input type="number" class="bk-form-input" v-model="tradeMode.price" name="validation_name" placeholder="建议售价 ¥20" style="width: 308px">
                    <!-- <i class="bk-icon icon-attention"></i> -->
                  </div>
                </div>
                <div class="bk-form-item">
                  <label class="bk-label">
                    <span class="bk-label-required"></span> 服务支持：</label>
                  <div class="bk-form-content">
                    <bk-selector :list="tradeMode.support.list" :selected.sync="tradeMode.support.selected" style="width: 310px; display: inline-block;">
                    </bk-selector>
                    <!-- <i class="bk-icon icon-attention"></i> -->
                  </div>
                </div>
              </div>
              <div v-else-if="tradeMode.selectedModel === 2">
                <div class="bk-form-item" style="margin-top: 20px">
                  <label class="bk-label">
                    <span class="bk-label-required"></span> 收费价格：</label>
                  <div class="bk-form-content">
                    <input type="number" class="bk-form-input" name="validation_name" placeholder="建议售价 2000G" style="width: 308px" v-model="tradeMode.price">
                    <!-- <i class="bk-icon icon-attention"></i> -->
                  </div>
                </div>
                <div class="bk-form-item">
                  <label class="bk-label">
                    <span class="bk-label-required"></span> 服务支持：</label>
                  <div class="bk-form-content">
                    <bk-selector :list="tradeMode.support.list" :selected.sync="tradeMode.support.selected" style="width: 310px; display: inline-block;">
                    </bk-selector>
                    <!-- <i class="bk-icon icon-attention"></i> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="upload-form upload-action">
            <a :class="['bk-button', 'bk-primary',{'is-loading':saveFlag === false}]" id="submit" @click="save" title="提交">
              <span>提交</span>
            </a>
            <a class="bk-button bk-return" title="返回" @click="leave">
              <span>返回</span>
            </a>
          </div>
        </form>
      </div>
    </div>
    <!-- 弹出框子组件 -->
    <v-alert :options="options"></v-alert>
  </div>
</template>

<script type="text/javascript">
  import Vue from 'vue'
  import vAlert from '../../alert.vue' //导入弹出框子组件
  import worksPictures from './common/works_pictures.vue'
  import tradingMode from '../works/trading_mode.vue'
  import selector from '../../selector/selector.vue'
  import tag from './tag.vue'

  export default {
    data() {
      return {
        ueditor:null,
        saveFlag: true, //提交按钮
        isLeaveConfirm: false,
        navList: [{
            href: '#info',
            top: 190,

            curStatus: 0,
            label: '填写基本资料'
          },
          {
            href: '#work',
            top: 760,

            curStatus: 0,
            label: '上传作品文件'
          },
          {
            href: '#upload',
            top: 1670,

            curStatus: 0,
            label: '选取作品图片'
          },
          {
            href: '#trade',
            top: 2370,

            curStatus: 0,
            label: '设置交易模式'
          }
        ],
        baseInformation: { // 基本资料
          name: { // 作品名称
            value: '',
            tips: '',
            isShow: false
          },
          sysType: { // 作品类型
            list: [],
            selected: -1,
            multiSelect: false
          },
          appID: { // 应用ID
            value: '',
            tips: '',
            isShow: false
          },
          funcType: { // 功能类型
            list: [],
            selected: -1,
            tips: '',
            isShow: false,
            multiSelect: false
          },
          overview: { // 简要概述
            value: '',
            tips: '',
            isShow: false
          },
          functionPoints: { // 功能点描述
            value: '',
            tips: '',
            isShow: false
          },
        },
        files: { // 上传作品文件
          version: { // 版本号
            value: '',
            tips: '',
            isShow: false
          },
          file: {}, // 版本文件
          fileId: [],
          message: '', // 相关信息
          address: { // 体验地址
            value: '',
            tips: '',
            isShow: false
          },
          devLanguage: { // 开发语言
            list: [],
            selected: [],
            searchable: true,
            multiSelect: true
          },
          browser: { // 浏览器兼容
            list: [],
            selected: [],
            searchable: true,
            multiSelect: true
          },
          surroundings: { // 部署环境
            list: [],
            selected: [],
            searchable: true,
            multiSelect: true
          },
          interface: { // 界面语言
            list: [],
              selected: [],
              searchable: true,
              multiSelect: true
          },
          classification: ['aa'] //分类标签
        },
        defaultDemo: {
          selected: 0
        },
        tradeMode: { // 设置交易模式
          model: [{
              title: "免费",
              type: 0
            }
          ],
          selectedModel: 0,
          openSource: { // 开源协议
            list: [],
            selected: -1
          },
          support: { // 服务支持
            list: [],
            selected: -1
          },
          price: '',
          freeUrl: ''
        },
        imagesIdList: [0, 0, 0, 0, 0],
        ableToUpload: false, // 能否上传
        options: {
          msgText: "",
          msgIsSuccess: true
        },
        loadingStatus: '',
        is_warning: [], //保存输入错误的项

      }
    },
    created() {
      this.getSelectedList();
    },
    methods: {
      checkScroll() {
        let scrollTop = document.querySelector('body').scrollTop
        this.navList.forEach(nav => {
          nav.status = ''
        })
        if (scrollTop < 700) {
          this.navList[0].status = 'editing'
        } else if (scrollTop >= 700 && scrollTop < 1590) {
          this.navList[0].status = 'success'
          this.navList[1].status = 'editing'
        } else if (scrollTop >= 1590 && scrollTop < 2300) {
          this.navList[1].status = 'success'
          this.navList[2].status = 'editing'
        } else if (scrollTop >= 2300) {
          this.navList[3].status = 'editing'
        }
      },
      leave() {
        this.isLeaveConfirm = true
      },
      confirmLeave() {
        this.isLeaveConfirm = false
        window.history.go(-1)
      },
      cancelLeave() {
        this.isLeaveConfirm = false
      },
      go(top, index) {
        this.navList.forEach(item => {
          this.status = ''
        })
        this.navList[index].status = 1,
          window.scrollTo(0, top)
      },
      /*
       ** 获取默认列表
       */
      getSelectedList() {
        axios.get(myUrl + 'core/product/labels/').then((res) => {
          let resData = res.data;
          if (resData.result) {
            this.baseInformation.sysType.list = resData.data.sys_choices; // 基础资料 -> 作品类型
            if (this.baseInformation.sysType.list.length) {
              this.baseInformation.sysType.selected = this.baseInformation.sysType.list[0].id
            }

            this.baseInformation.funcType.list = resData.data.func_choices; //基础资料 -> 功能类型
            if (this.baseInformation.funcType.list.length) {
              this.baseInformation.funcType.selected = this.baseInformation.funcType.list[0].id
            }
            
            this.files.devLanguage.list = resData.data.lbl_dev_lang; // 上传作品文件 -> 开发语言

            this.files.browser.list = resData.data.lbl_browser; // 上传作品文件 -> 浏览器兼容
            this.files.surroundings.list = resData.data.lbl_env; // 上传作品文件 -> 部署环境
            this.files.interface.list = resData.data.lbl_i18n; // 上传作品文件 -> 界面语言
            this.files.classification = []; // 上传作品文件 -> 分类标签 resData.data.lgl_category
            this.tradeMode.openSource.list = resData.data.free_choices; // 设置交易模式 -> 开源协议
            this.tradeMode.support.list = resData.data.support_choices; // 设置交易模式 -> 服务支持
          } else {
            // 错误提示
            this.options = {
              msgIsSuccess: false,
              msgText: res.message
            }
          }
        })
      },
      /*
       ** 点击切换
       */
      tabChange(index) {
        var anchor = this.$el.querySelector('#anchor-' + (index + 1));
        this.$el.querySelector('.bk-form').scrollTop = anchor;
      },
      /*
       ** 选择上传文件
       */
      handleFile(e) {
        let fileInfo = e.target.files[0];
        let maxSize = 100000; // 500kb
        let fileSize = fileInfo.size / 1024; // kb
        let fileName = fileInfo.name;
        this.loadingStatus = 'start';

        //判断上传的文件大小
        if (fileSize <= maxSize) {
          if (/.zip$/.test(fileName)) {
            this.files.file = fileInfo;
            this.ableToUpload = true;

            // 全部判断通过后，调用文件上传接口
            let data = new FormData();
            data.append("file", fileInfo);
            data.append('file_type', 0) //定值，0为文件，1为图片
            data.append('file_name', fileName)
            data.append('file_format', 'file')

            axios.post(myUrl + 'core/product/upload/', data, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
            }).then((res) => {
              let resFileData = res.data;
              if (resFileData.result) {
                this.loadingStatus = 'complete';
                this.files.fileId = [];
                this.files.fileId.push(resFileData.data);
              } else {
                // 错误提示
                this.options = {
                  msgIsSuccess: false,
                  msgText: res.message
                }
              }
            }, res => {
              // 错误提示
              this.options = {
                msgIsSuccess: false,
                msgText: '接口异常！'
              }
            })
          } else {
            this.ableToUpload = false;
            this.options = {
              msgIsSuccess: false,
              msgText: '文件格式非法，只能上传zip文件！'
            }
          }
        } else {
          this.options = {
            msgIsSuccess: false,
            msgText: '该文件大小超过500MB！'
          }
        }
      },
      /*
       ** 删除上传文件
       */
      deleteFile() {
        this.ableToUpload = false;
      },
      /*
       ** 查找指定元素是否在数组中
       */
      findItem(item, array) {
        let has_item = array.find((el, index, arr) => {
          return el == item;
        })

        if (has_item == item) {
          return true;
        } else {
          return false;
        }
      },
      /*
       ** 从指定数组中删除元素
       */
      removeItem(item, array) {
        array.find((el, index, arr) => {
          if (el == item) {
            array.splice(index, 1);
            return;
          }
        });
      },
      /*
       ** 检查当前项是否在错误数组中
       */
      input_warning(str) {
        
        let hasWarning = this.is_warning.indexOf(str)
        return {
          warning: hasWarning === -1 ? false : true
        }
      },
      /*
      /*
       ** 验证输入合法性
       */
      checkValidate(type) {
        let baseInformation = this.baseInformation;
        let files = this.files;
        let validateState = false;
        switch (type) {
          case 'baseInformation.appID':
            if (!(/^[A-Za-z][A-Za-z0-9|-]{2,15}$/).test(this.baseInformation.appID.value)) {
              this.baseInformation.appID.isShow = true;
              this.baseInformation.appID.tips = "由小写英文字母，连接符(-)或数字组成，长度为3~16个字符，并且以字母开头";
              validateState = true;
            }
            break;

          case 'baseInformation.functionPoints':
            if (!this.baseInformation.functionPoints.value.length) {
              baseInformation.functionPoints.isShow = true;
              baseInformation.functionPoints.tips = "请输入合法功能点描述（5000个字符以内）";
              validateState = true;
            }
            break;

          case 'files.version':
            if (!(/^\d+(\.\d+){0,2}$/).test(this.files.version.value)) {

              files.version.isShow = true;
              files.version.tips = "请输入合法版本号（2位式：1.5 / 3位式：1.5.0）";
              validateState = true;
            }
            break;

          case 'files.address':
            if (!this.files.address.value){
              files.address.isShow = false;
              break;
            }
            if (!(/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/).test(
                this.files.address.value)) {

              files.address.isShow = true;
              files.address.tips = "请输入合法的体验地址";
              validateState = true;
            }
            break;
        }

        if (validateState) {
          let has_type = this.findItem(type, this.is_warning);
          if (!has_type) {
            this.is_warning.push(type);
          }
        } else {
          this.removeItem(type, this.is_warning);
        }
      },
      /*
       ** 验证用户输入
       */
       initEditor(){
        if (UM.getEditor('myEditor') && UM.getEditor('myEditor').destroy) {
          UM.getEditor('myEditor').destroy();
        }
        
        this.ueditor = UM.getEditor('myEditor');
        this.ueditor.setWidth("98%");
      },
    
      validate() {
        //若错误列表中有项，滚动至页面顶部
        let is_warning = this.is_warning;
        if (!is_warning.length) {
          //  没有错
          return true;
        } else {
          window.scrollTo(0, 0);
          return false;
        }
      },
      goAnchor(selector) {
         let anchor = this.$el.querySelector(selector)
          document.body.scrollTop = anchor.offsetTop; // chrome
          document.documentElement.scrollTop = anchor.offsetTop; // firefox
          $('selector').find('.biz-searcher').css('border','1px solid red');
      },
      checkParams(params) {
        // return true
        if (params.name.length < 4 || params.name.length > 20) {
          
          this.goAnchor('#anchor-1');
          this.options = {
            msgText: '请输入作品名称',
            msgIsSuccess: false
          }
          $('.bk-form-content .bk-form-input.workName').addClass("wrong");
          this.baseInformation.name.isShow = true;
          this.baseInformation.name.tips = "请输入合法作品名称（4~8个中文字符）";
          return false
        } else {
          $('.bk-form-content .bk-form-input.workName').removeClass("wrong");
        }
        if (params.sys_type === 1 && !params.app_code) {
          
          this.goAnchor('#anchor-1');
          this.options = {
            msgText: '请输入应用ID',
            msgIsSuccess: false
          }
          $('.bk-form-content .bk-form-input.workId').addClass("wrong");
          this.baseInformation.name.isShow = true;
          this.baseInformation.name.tips = "由小写英文字母，连接符(-)或数字组成，长度为3~16个字符，并且以字母开头";
          return false
        } else {
          $('.bk-form-content .bk-form-input.workId').removeClass("wrong");
        }
        
        if (!params.desc) {
          
          this.goAnchor('#anchor-1');
          this.options = {
            msgText: '请输入简要概述',
            msgIsSuccess: false
          }
          $('.bk-form-content .simpleDescription').addClass('wrong');
          return false
        } else {
          $('.bk-form-content .simpleDescription').removeClass('wrong');
        }

        if (!params.feature) {
          
          this.goAnchor('#anchor-1');
          this.options = {
            msgText: '请输入功能点描述',
            msgIsSuccess: false
          }
          $('.edui-container').parent().addClass('wrong');
          return false
        } else {
          $('.edui-container').parent().removeClass('wrong');
        }

        if (!params.version) {
          this.goAnchor('#anchor-2');
          this.options = {
            msgText: '请输入版本号',
            msgIsSuccess: false
          }
          $('.bk-form-content .versionNum').addClass('wrong');
          return false
        } else {
          $('.bk-form-content .versionNum').removeClass('wrong');
        }

        if (params.files === '[]') {
          
          this.goAnchor('#anchor-2');
          this.options = {
            msgText: '请选择版本文件',
            msgIsSuccess: false
          }
          return false
        }

        

        if (params.lang === '[]') {
          
          this.goAnchor('#anchor-2');
          this.options = {
            msgText: '请选择开发语言',
            msgIsSuccess: false
          }
          return false
        }

        if (params.browser === '[]') {
          
          this.goAnchor('#anchor-2');
          this.options = {
            msgText: '请选择浏览器兼容',
            msgIsSuccess: false
          }
          return false
        }

        if (params.env === '[]') {
          
          this.goAnchor('#anchor-2');
          this.options = {
            msgText: '请选择部署环境',
            msgIsSuccess: false
          }
          return false
        }

        if (params.i18n === '[]') {
          
          this.goAnchor('#anchor-2');
          this.options = {
            msgText: '请选择界面语言',
            msgIsSuccess: false
          }
          return false
        }

        if (params.tags === '[]') {
          
          this.goAnchor('#anchor-3');
          this.options = {
            msgText: '请设置分类标签',
            msgIsSuccess: false
          }
          $('.bk-form-content .biz-searcher').addClass('wrong');
          return false
        } else {
          $('.bk-form-content .biz-searcher').removeClass('wrong');
        }

        if (!this.imagesIdList[0]) {
          this.goAnchor('#anchor-3');
          this.options = {
            msgText: '请上传作品LOGO',
            msgIsSuccess: false
          }
          return false
        }

        if (!this.imagesIdList[1]) {
          this.goAnchor('#anchor-3');
          this.options = {
            msgText: '请上传作品封面',
            msgIsSuccess: false
          }
          return false
        }

        if (!this.imagesIdList[2] && !this.imagesIdList[3] && !this.imagesIdList[4]) {
          this.goAnchor('#anchor-3');
          this.options = {
            msgText: '请上传至少1张作品截图',
            msgIsSuccess: false
          }
          return false
        }

        return true
      },
      /*
       ** 提交保存
       */
      save() {
        this.saveFlag = false;
        setTimeout(() => {
          this.saveFlag = true
        }, 5000)
        if (!this.validate()) {
          return true;
        } else {
          // let isEmpty = false // 是否表单未填写
          let baseInformation = this.baseInformation
        
          let price = this.tradeMode.price
          let model = 0
          if (this.tradeMode.selectedModel == 0) {
            price = 0
            model = 0
          } else if (this.tradeMode.selectedModel == 1) {
            model = 1
          } else if (this.tradeMode.selectedModel == 2) {
            model = 2
          }
          
          let files = this.files,
            params = {
              name: baseInformation.name.value,
              sys_type: baseInformation.sysType.selected,
              app_code: baseInformation.appID.value,
              func_type: baseInformation.funcType.selected,
              desc: baseInformation.overview.value,
              feature: UM.getEditor('myEditor').getContent(),
              version: files.version.value,
              changelog: files.message,
              bk_version: '1.0.0',
              test_url: files.address.value,
              lang: JSON.stringify(files.devLanguage.selected),
              browser: JSON.stringify(files.browser.selected),
              env: JSON.stringify(files.surroundings.selected),
              i18n: JSON.stringify(files.interface.selected),
              tags: JSON.stringify(files.classification),
              images: JSON.stringify(this.imagesIdList),
              files: JSON.stringify(files.fileId),
              trade: JSON.stringify({
                "free_url": this.tradeMode.freeUrl,
                "price": price,
                "mode": model,
                "protocol": this.tradeMode.openSource.selected,
                "support": this.tradeMode.support.selected
              })
            }
          console.log(params)
          if (!this.checkParams(params)) {
            return false
          }
          axios.post(myUrl + 'core/product/publish/', qs.stringify(params)).then((response) => {
            let res = response.data
            if (res.result) {
              this.saveFlag = true;
              this.options = {
                msgText: res.message,
                msgIsSuccess: true
              }
              setTimeout(() => {
                window.scrollTo(0, 0)
                this.$router.push({
                  path: '/s-mart/personal_center/works/'
                })
              }, 3000)
            } else {
              this.options = {
                msgText: res.message,
                msgIsSuccess: false
              }
            }
          }, reject => {
            this.options = {
              msgText: reject.message,
              msgIsSuccess: false
            }
          })
        }


      },

      /*
       ** 监听上传图片子组件
       */
      allPictureIds(data) {
        switch (data.type) {
          case 'logo':
            this.imagesIdList[0] = data.imgId;
            this.navList[2].curStatus = 1;
            break;

          case 'cover':
            this.imagesIdList[1] = data.imgId;
            break;

          case 'firstAvatar':
            this.imagesIdList[2] = data.imgId;
            break;

          case 'secondAvatar':
            this.imagesIdList[3] = data.imgId;
            break;

          case 'thirdAvatar':
            this.imagesIdList[4] = data.imgId;
            this.navList[2].curStatus = 2;
            break;
        }
      },
      removePicture(data) {
        switch (data.type) {
          case 'logo':
            this.imagesIdList[0] = 0;
            break;

          case 'cover':
            this.imagesIdList[1] = 0;
            break;

          case 'firstAvatar':
            this.imagesIdList[2] = 0;
            break;

          case 'secondAvatar':
            this.imagesIdList[3] = 0;
            break;

          case 'thirdAvatar':
            this.imagesIdList[4] = 0;
            break;
        }
      },
      judgeBaseInformation() {
        if (this.baseInformation.name.value === '' && this.baseInformation.appID.value && this.baseInformation.overview
          .value === '' && this.baseInformation
          .functionPoints.value === ''
        ) {
          this.navList[0].curStatus = 0;
        } else if (this.baseInformation.name.value !== '' && this.baseInformation.appID.value !== '' && this.baseInformation
          .overview.value !== '' && this.baseInformation.functionPoints.value !== ''
        ) {
          this.navList[0].curStatus = 2;
        } else {
          this.navList[0].curStatus = 1;
        }
      },
      judgeFileInfo() {
        if (this.files.version.value === '' && this.files.message === '' && this.files
          .classification.length === 0) {
          this.navList[1].curStatus = 0;
        } else if (this.files.version.value !== '' && this.files.message !== '') {
          this.navList[1].curStatus = 2;
        } else {
          this.navList[1].curStatus = 1;
        }
      },

      judgeTradeModel() {
        if (this.trade.free_url === '') {
          this.navList[3].curStatus = 0;
        } else if (!this.trade.free_url) {
          this.navList[3].curStatus = 2;
        } else {
          this.navList[3].curStatus = 1;
        }
      },
      

    },
    mounted() {
      this.initEditor();
    },
    watch: {
      'baseInformation.name.value' () {
        this.judgeBaseInformation()
      },
      'baseInformation.appID.value' () {
        this.judgeBaseInformation()
      },
      'baseInformation.overview.value' () {
        this.judgeBaseInformation()
      },
      'baseInformation.functionPoints.value' () {
        this.judgeBaseInformation()
      },
      'files.version.value' () {
        this.judgeFileInfo()
      },

      'files.message' () {
        this.judgeFileInfo()
      }

    },
   
    components: {
      worksPictures,
      tradingMode,
      vAlert,
      selector,
      tag
    }
  }
</script>

<style media="screen" lang="scss">
  .user-upload {
    .bk-button {
      float: none;
      &.bk-primary,
      &.bk-return {
        width: 93px;
        margin-right: 10px;
      }
      &.bk-notclick {
        background-color: rgba(0, 0, 0, .3);
      }
    }
    .app-detail {
      .icon-upper {
        width: 7px;
        height: 12px;
        display: inline-block;
        background: url(../../../images/personal_center/icon-left.png) no-repeat;
        background-size: cover;
        margin: 25px 0;
      }
    }
  }

  .bk-personal_center {
    .user-upload {
      .left-wrapper {
        .list-box {
          background: none;
          padding: 0;
          li {
            height: 48px;
            overflow: hidden;
            line-height: 48px;
            background: #fafafa;
            margin-bottom: 4px;
            color: #a6a6a6;
            padding: 0 18px;
            text-align: left;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            .icon-check-circle-shape {
              font-size: 24px;
              margin-right: 10px;
              position: relative;
              top: 5px;
            }
            &.success,
            &:hover {
              background: #ffffff;
            }
            &.success {
              color: #a474f3;
              a {
                color: #a474f3;
              }
              .process {
                background: none;
                color: #ffffff;
              }
            }
            &.editing {
              background: #a474f3;
              color: #ffffff;
              a {
                color: #ffffff;
              }
              .process {
                background: #ffffff;
                color: #a474f3;
              }
            }
          }
        }
      }
      .bk-form {
        margin-left: 0;
        margin-right: 0;
        position: relative;
        .bk-label {
          position: relative;
          font-size: 14px;
          color: #a6a6a6;
          padding: 13px 28px 13px 0;
          .bk-label-required {
            width: 5px;
            height: 6px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 14px;
            letter-spacing: 0px;
            color: #ff6600;
          }
        }

        .bk-form-item {
          &:first-child {
            margin-top: 0;
            line-height: 36px;
          }
          &:last-child {
            .bootstrap-tagsinput {
              width: 614px;
              min-height: 38px;
              border: 1px solid #c3cdd7;
              line-height: 36px;
              padding: 0 10px;
              .tag.label.label-info {
                display: inline-block;
                height: 22px;
                line-height: 20px;
                padding: 0 10px;
                margin-right: 5px;
                margin-bottom: 5px;
                background-color: #fafafa;
                border-radius: 2px;
                border: solid 1px #e6e6e7;
                color: #888991;
                font-size: 12px;
              }
            }
          }
          .tag-content {
            width: 614px;
            border: solid 1px #c3cdd7;
            padding-top: 7px;
            display: table;
            -webkit-transition: border .35s;
            transition: border .35s;
          }
          .bk-form-tag {
            display: inline-block;
            padding: 0 9px;
            line-height: 20px;
            height: 22px;
            border: solid 1px #e6e6e7;
            background: #fafafa;
            margin: 0 0 7px 5px;
            float: left;
          }
          .input-tag {
            height: 22px;
            line-height: 22px;
            display: inline-block;
            border: none;
            margin-bottom: 7px;
            width: 100px;
            min-width: 100px;
            max-width: 400px;
          }
        }
        .upload-form {
          padding: 40px 20px;
          &.upload-action {
            display: table;
            padding: 22px 30px;

          }
          &.upload-form-border {
            border-top: solid 1px #f4f4f4;
          }
        }
        .bk-form-input,
        .bk-form-password,
        .bk-form-select,
        .bk-form-textarea {
          color: #4f515e;
        }
        .bk-form-textarea {
          line-height: 24px;
          min-height: 168px;
          &::-webkit-input-placeholder:after {
            display: block;
            content: "line@ \A line#";
            /*  \A 表示换行  */
            color: red;
          }
        }
      }
    }
  }
  
</style>
<style media="screen" lang="scss" scoped>
  .wrong {
    border: 1px solid #c94d3c !important;
  
  }
  .icon-attention {
    width: 16px;
    height: 16px;
    position: relative;
    top: 5px;
    margin-left: 5px;
    display: inline-block;
    background: url(../../../images/application_detail/icon-info.png) no-repeat;
  }

  .app-detail {
    width: 100%;
    height: 60px;
    background: #fff;
    margin-bottom: 10px;
    .app-link {
      display: inline-block;
      width: 27px;
      height: 60px;
      text-align: center;
      border-right: solid 1px #f4f4f4;
    }
    .app {
      padding: 11px 8px;
      width: 221px;
      float: right;
      height: 60px;
      span {
        line-height: 38px;
        max-width: 157px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        padding-left: 10px;
        font-size: 16px;
        color: #888991;
        font-weight: bold;
      }
      .app-img {
        width: 38px;
        height: 38px;
        display: inline-block;
        float: left;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .process {
    display: inline-block;
    font-style: normal;
    background: #f4f4f4;
    text-align: center;
    width: 24px;
    height: 24px;
    line-height: 24px;
    margin-right: 10px;
    color: #a6a6a6;
    border-radius: 50%;
    font-size: 16px;
    font-weight: bold;
  }

  .upload-panel {
    /* padding: 0 0 20px 0; */
    border-bottom: 4px solid #f4f4f4;
    h4 {
      font-size: 14px;
      color: #4f515e;
      height: 60px;
      line-height: 60px;
      padding: 0 30px;
      border-bottom: solid 1px #f4f4f4;
    }
  }

  .upload-file {
    position: relative;
    text-align: left;
    line-height: 36px;
    .bk-form-input {
      padding: 0;
      line-height: 36px;
      width: 96px;
      text-align: center;
      float: left;
    }
    .bk-form-tips {
      display: inline-block;
      color: #4f515e;
      padding-left: 30px;
    }
    input[type='file'] {
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      width: 96px;
      height: 36px;
      cursor: pointer;
    }
  }

  .bk-form-number {
    display: inline-block;
    line-height: 36px;
    color: #a6a6a6;
    padding-left: 5px;
  }

  .bk-form-content {
    position: relative;
    
  }
  

  .tips {
    display: none;
  }

  .warning .tips {
    display: block;
    background: #090b1a;
    position: absolute;
    white-space: nowrap;
    color: #fff;
    top: -40px;
    left: 50%;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    border-radius: 2px;
    text-align: center;
    transform: translateX(-50%);
    -o-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    &:after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -14px;
      width: 0;
      height: 0;
      border: 10px solid #090b1a;
      /* border: 1px solid red; */
      border-color: #090b1a transparent transparent transparent;
      margin-left: -10px;
    }
  }

  .bk-upload-ul {
    margin-top: 5px;
    .bk-list-li {
      height: 60px;
      border: 1px solid #e6e6e7;
      border-radius: 2px;
      padding: 15px;
      width: 380px;
      display: inline-block;
      .icon-file-zip {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url(../../../images/application_detail/icon-file-zip.png) no-repeat;
        margin-right: 10px;
        top: -10px;
      }
      .bk-list-content {
        vertical-align: top;
        top: -10px;
        width: 300px;
        float: right;
        position: relative;
        .bk-load {
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0;
          height: 4px;
          background: #e6e6e7;
          display: inline-block;
          border-radius: 2px;
          >span {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 3px;
            width: 0;
            background: #57a3f1;
            -webkit-transition: all .5s;
            -moz-transition: all .5s;
            -ms-transition: all .5s;
            transition: all .5s;
          }
          .loading {
            width: 90%;
          }
          .totalLoading {
            width: 100%;
          }
        }
        .name {
          width: 90%;
          display: inline-block;
          height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          line-height: 40px;
          color: #888991;
        }
        .icon-close {
          position: absolute;
          right: 0;
          cursor: pointer;
          top: 13px;
          left: auto;
          font-size: 12px;
        }
        .icon-check-1 {
          position: absolute;
          right: 0;
          cursor: pointer;
          top: 13px;
          left: auto;
          color: #5bd18b;
          font-size: 12px;
        }
      }
    }
  }

  .pop-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .3);
    z-index: 1111;
    .pop-box {
      width: 400px;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: 20px;
      border-radius: 3px;
      .pop-header {
        margin-bottom: 10px;
      }
      .pop-body {
        text-align: center;
        font-size: 22px;
        color: #333;
        width: 100%;
      }
      .pop-footer {
        padding: 20px 45px 20px;
        text-align: center;
        font-size: 0;
        .yes,
        .no {
          font-size: 16px;
          height: 36px;
          line-height: 36px;
          border-radius: 3px;
          display: inline-block;
          width: 110px;
        }
        .yes {
          color: #fff;
          background: #57a3f1;
          margin-right: 20px;
        }
        .no {
          color: #666;
          border: 1px solid #e5e5e5;
        }
      }
    }
  }
  .bk-personal_center .user-upload .bk-form #anchor-1 .upload-form .bk-form-item .bk-form-content .edui-container{
    width:616px !important;
  }
  
</style>


// WEBPACK FOOTER //
// user_upload.vue?4ee57a03